import { Attributes } from "@lib/enums/ProductAttributes";
import { getProductAttributeValue } from "@lib/utils/attributesUtils";
import { isNumber, isString } from "lodash-es";
import type { ProductVariant } from "@lib/product/types";
import type { ProductVariant as RawProductVariant } from "@graphql/generated/types";

export const getImperialSizeForProduct = (variant: ProductVariant | RawProductVariant) => {
    const size = getProductAttributeValue(variant?.attributesRaw, Attributes.sizeUS);
    const hasSizeUS = isString(size) || isNumber(size);
    return hasSizeUS ? String(size) : "";
};
